  <div #divSupplierChild>
    <supplier-registration-form #supplierChild  class="block" 
    *ngIf="!isSubmitSucceededEvent"
    [SupplierIdInput] = "selectedSupplierId"
    [CategoryIdInput] ="categoryId"
    [IsInActivateStepInput]="isInActivateStepInput">
    </supplier-registration-form >
  </div>
  
  <div *ngIf="!isRequestHistory" #divTechnicalApprovalChild>
    <supplier-registration-aproval #technicalApprovalChild
    (isSubmitSucceededEvent)="receiveIsSubmitSucceededEvent($event)"
    [ApprovalLevelInput]="approvalLevel"
    [WFAppInstanceIDInput]= "wfAppInstanceId"
    [SupplierIdInput]= "selectedSupplierId">
    </supplier-registration-aproval>  
  </div>